/* @flow */

import * as React from 'react';
import { useCallback } from 'react';
import QRCode from 'react-qr-code';

import type { BasicFunction } from '../../../helpers/jsHelpers/types';

import Localizer from '../../../helpers/localization';
import { Messenger, MessengerEvents } from '../../../helpers/messenger';
import ButtonFX from '../../buttons/ButtonFX';
import './PurchaseRedirect.css';

type PurchaseRedirectPropType = {
  +onClose: BasicFunction,
  +url: string,
};

const PurchaseRedirect = ({ onClose, url }: PurchaseRedirectPropType): React.Node => {
  const handleUpdateOnClick = useCallback(() => {
    Messenger.emit(MessengerEvents.REFRESH_PURCHASE_LIST);
    onClose();
  }, []);

  return (
    <div className='purchaseRedirect'>
      <div className='purchaseRedirectTitle'>{Localizer.localize('vod.redirect.title')}</div>
      <div className='purchaseRedirectContainer'>
        <div className='purchaseRedirectMessage'>{Localizer.localize('vod.redirect.message')}</div>
        <div className='qrCodeContainer'>
          <QRCode size={140} value={url} />
        </div>
      </div>
      <ButtonFX onClick={handleUpdateOnClick}>{Localizer.localize('vod.redirect.update_button')}</ButtonFX>
    </div>
  );
};

export default PurchaseRedirect;
